export default "__VITE_ASSET__D1mm4EN9__"